import { NgModule } from "@angular/core";
import { FranchiseRoutingModule } from "./franchise-routing.module";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CarouselModule } from "ngx-owl-carousel-o";
import { OwlDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { MainComponent } from './main/main.component';
import { PromoteComponent } from './promote/promote.component';
import { RemunerationComponent } from './remuneration/remuneration.component';
import { CommonModule } from "@angular/common";
import { LocationCampaignsComponent } from './location-campaigns/location-campaigns.component';
import { AdminModule } from "../admin/admin.module";
import { TopFranchisedComponent } from './main/top-franchised/top-franchised.component';
import { LatestAdvertisingCampaignsComponent } from './main/latest-advertising-campaigns/latest-advertising-campaigns.component';

@NgModule({
  declarations: [
    MainComponent,
    PromoteComponent,
    RemunerationComponent,
    LocationCampaignsComponent,
    TopFranchisedComponent,
    LatestAdvertisingCampaignsComponent,
  ],
  imports: [
    CommonModule,
    FranchiseRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    OwlDateTimeModule,
    AdminModule
  ],
  exports: []
})
export class FranchiseModule {}
